import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { useReactToPrint } from "react-to-print";

const Printable = forwardRef(
  (
    {
      children,
      reportTitle,
      html,
      companyName,
      data,
      documentTitle = "Document",
    },
    ref,
  ) => {
    const contentRef = useRef(null);

    const handlePrint = useReactToPrint({
      contentRef,
      documentTitle,
      data,
      removeAfterPrint: true,
    });

    useImperativeHandle(ref, () => ({
      handlePrint,
    }));

    return (
      <div
        ref={contentRef}
        style={{
          color: "#000",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh", // A4 height approx at 96dpi
          width: "100%",
        }}
      >
        {/* Header */}
        {companyName && (
          <div
            style={{
              textAlign: "center",
              fontSize: "22px",
              fontWeight: "bold",
              padding: "10px",
              borderBottom: "2px solid #000",
            }}
          >
            {companyName}
          </div>
        )}

        {reportTitle && (
          <div
            style={{
              textAlign: "center",
              fontSize: "22px",
              fontWeight: "bold",
              padding: "10px",
              borderBottom: "2px solid #000",
            }}
          >
            {reportTitle}
          </div>
        )}

        {/* ✅ CONTENT AREA (THIS IS IMPORTANT) */}
        <div style={{ flex: 1 }}>
          {html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : children}
        </div>

        {/* ✅ FOOTER (STICKY BOTTOM) */}
        {/* <div
          style={{
            textAlign: "center",
            fontSize: "10px",
            marginTop: "auto",
            padding: "10px 0",
          }}
        >
          This is computer generated no signature required
        </div> */}
      </div>
    );
  },
);

Printable.displayName = "Printable";

export default Printable;
